export default __webpack_public_path__ + "static/media/medal.3dd20c6f.png";